export default __webpack_public_path__ + "static/media/check-done.b872937e.svg";